import { render, staticRenderFns } from "./SnowflakeAccountTable.vue?vue&type=template&id=f4b1a394&scoped=true&"
import script from "./SnowflakeAccountTable.vue?vue&type=script&lang=ts&"
export * from "./SnowflakeAccountTable.vue?vue&type=script&lang=ts&"
import style0 from "./SnowflakeAccountTable.vue?vue&type=style&index=0&id=f4b1a394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b1a394",
  null
  
)

/* custom blocks */
import block0 from "./SnowflakeAccountTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports